import React, { useContext, useState } from "react";

const QuestionContext = React.createContext();
const SetQuestionContext = React.createContext();

export function useQuestion() {
  return useContext(QuestionContext);
}

export function useSetQuestion() {
  return useContext(SetQuestionContext);
}

export function QuestionProvider({ children }) {
  // const [question, setQuestion] = useState({
  //   name: "",
  //   requirements: [
  //     "Make a div with a width and height of 200px",
  //     "Give the div a background color of blue",
  //     "Center text in the middle of the div saying 'blue square'",
  //   ],
  //   answer:
  //     '<div style="background-color:blue;width:200px;height:200px;display:flex;justify-content:center;align-items:center;"><h1>Blue Square</h1></div>',
  // });
  const [question, setQuestion] = useState({});

  return (
    <QuestionContext.Provider value={question}>
      <SetQuestionContext.Provider value={setQuestion}>
        {children}
      </SetQuestionContext.Provider>
    </QuestionContext.Provider>
  );
}
